import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type PurchaseButtonProps = {
  children: React.ReactNode;
  compact?: boolean;
};
export function PurchaseButton({
  children,
  compact = false
}: PurchaseButtonProps) {
  return <a href="https://tufenixdigital.store/cart/54015058936172:1" className={`inline-flex items-center justify-center gap-2 rounded-full bg-[#bf5e42] text-center font-black text-[#fffaf1] shadow-lg shadow-[#4b2d24]/20 transition-[background-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#a64d36] hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-[#e9bba9] ${compact ? 'min-h-11 px-5 text-xs' : 'min-h-14 w-full px-5 py-3 text-sm sm:w-auto sm:px-7'}`} data-id="element-1">
      {children}
      <ArrowRightIcon size={compact ? 15 : 18} aria-hidden="true" data-id="element-2" />
    </a>;
}